import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { DateFormatService } from '../service/date-format.service';
 
@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {

  constructor(private dateFormatService: DateFormatService) {
    super();
  }
	
  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date: DateTime = DateTime.fromFormat(value, this.dateFormatService.getFormat());
      return {
        day: date.day,
        month: date.month,
        year: date.year
      };
    }
    return null;
  }
 
  format(date: NgbDateStruct): string {
    return date ? DateTime.local(date.year, date.month, date.day).toFormat(this.dateFormatService.getFormat()) : '';
  }
 
}